"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _reactLoadScript = _interopRequireDefault(require("react-load-script"));

var _styledComponents = require("styled-components");

var _getFormMethods2 = _interopRequireDefault(require("../Form/getFormMethods"));

var _ReCaptcha = require("./ReCaptcha.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ReCaptcha = function ReCaptcha(_ref) {
  var id = _ref.id,
      siteKey = _ref.siteKey;

  var _getFormMethods = (0, _getFormMethods2["default"])({
    mode: 'onBlur'
  }),
      errors = _getFormMethods.errors,
      setValue = _getFormMethods.setValue,
      register = _getFormMethods.register;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var fieldErrors = errors[id];
  (0, _react.useEffect)(function () {
    register({
      name: id
    });
  }, [register, id]);
  (0, _react.useEffect)(function () {
    var captchaValidCallback = function captchaValidCallback(response) {
      return setValue(id, response);
    };

    var captchaInvalidCallback = function captchaInvalidCallback() {
      return setValue(id, '');
    };

    if (typeof window !== 'undefined' && window.grecaptcha && window.grecaptcha.render && loaded) {
      window.grecaptcha.render(id, {
        'error-callback': captchaInvalidCallback,
        'expired-callback': captchaInvalidCallback,
        callback: captchaValidCallback,
        sitekey: siteKey
      });
    } else if (loaded) {
      // ReCAPTCHA can take a moment to initialize, wait for it to do so.
      setLoaded(false);
      setTimeout(function () {
        return setLoaded(true);
      }, 200);
    }
  }, [loaded, id, siteKey, setValue]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactLoadScript["default"], {
    attributes: {
      type: 'text/javascript',
      src: 'https://www.google.com/recaptcha/api.js',
      id: 'ReCaptchaScript',
      render: 'explicit'
    },
    onLoad: function onLoad() {
      setLoaded(true);
    },
    url: "https://www.google.com/recaptcha/api.js"
  }), fieldErrors && /*#__PURE__*/_react["default"].createElement(_ReCaptcha.StyledReCaptchaError, null, fieldErrors.message), /*#__PURE__*/_react["default"].createElement("div", {
    id: id
  }));
};

ReCaptcha.defaultProps = {
  id: ''
};
ReCaptcha.propTypes = {
  /** Sets both the ReCAPTCHA div ID and form name as available. */
  id: _propTypes.string,

  /** The ReCAPTCHA siteKey. */
  siteKey: _propTypes.string.isRequired
};
ReCaptcha.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ReCaptcha",
  "props": {
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Sets both the ReCAPTCHA div ID and form name as available.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "siteKey": {
      "description": "The ReCAPTCHA siteKey.",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(ReCaptcha);

exports["default"] = _default;